module.exports = __webpack_public_path__ + "img/select01.5c0b4297.png";